import { useDeviceName } from 'lib/api/myRobot';

import { KeyPathParser, useTwinFetcherQuery, useTwinQuerySub } from '../signalR';

export function useReportedSpotFaults() {
  const { deviceName } = useDeviceName();

  const { keyPath, parser } = KeyPathParser.SpotFaults;
  const { data } = useTwinQuerySub(keyPath(deviceName), parser);

  return { data };
}

export function useActiveFaults() {
  const { deviceName } = useDeviceName();

  const { keyPath, parser } = KeyPathParser.SpotFaults.activeFaults;
  const { data: activeFaults } = useTwinFetcherQuery(keyPath(deviceName), parser);

  return { activeFaults };
}
